seedWebApp.controller('IndexOrdersCtrl', ['$scope', '$routeParams', '$location', '$window',
function ($scope, $routeParams, $location, $window) {

    console.log('IndexOrders');
    $scope.loadingTabs = false;
    $scope.selectedIndex = 0;

    $scope.defaultPages = [
        { pageIndex: 0, pageLabel: 'Shipping Schedule', pageDisplay: 'Orders/Orders', pageUrl: 'SPA/orders/orders.html' + seedWebApp.buildVersion },

        //{ pageIndex: 1, pageLabel: 'Processos Exportação', pageDisplay: 'Orders/Orders', pageUrl: 'SPA/orders/procExps.html' },
        //{ pageIndex: 2, pageLabel: 'Ordens Venda SAP', pageDisplay: 'Orders/SapItems', pageUrl: 'SPA/orders/sapItems.html' },    
        //{ pageIndex: 3, pageLabel: 'Reconciliar OVs', pageDisplay: 'Orders/OrdersReconcile',  pageUrl: 'SPA/orders/ordersReconcile.html' },    
        //{ pageIndex: 4, pageLabel: 'Sugestões', pageDisplay: 'Orders/Hints', pageUrl: 'SPA/orders/hints.html' }            
    ];

    $scope.loadingTabs = true;
    $scope.selTab = $routeParams.Tab;

    //$scope.selOrderID = $routeParams.id;
    //console.log('selOrderID: ' + $scope.selOrderID);

    $scope.tabSelected = function (page) {
        //$location.search('Tab', page.pageIndex);
        $scope.selectedIndex = page.pageIndex;
    };

    $(document).ready(function () {
        $scope.overflowSize = $scope.AdjustSize();
        console.log('document.ready.AdjustSize ' + $scope.overflowSize);
    });

    $window.onresize = function () {
        $scope.overflowSize = $scope.AdjustSize();
    };

    $scope.$watch('modules', function () {
        if ($scope.modules) {
            $scope.verifyPermsAndDefineTabs($scope, 'Orders');
        }
    });
}
]);